'use client';

import { useFormContext } from 'react-hook-form';

import type { LanguageMultiSelectorProps } from '@/components/Language/LanguageMultiSelector';
import LanguageMultiSelector from '@/components/Language/LanguageMultiSelector';
import type { GeneralFormProps } from '@/types/general';

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormMessage,
} from '../ui/form';

type RHFLanguageMultiSelectorProps = {
  name: string;
  title?: string;
  description?: string;
} & Omit<LanguageMultiSelectorProps, 'name' | 'title' | 'description' | 'value' | 'onChange'>
& Omit<GeneralFormProps, 'onChange'>;

/**
 * React Hook Form wrapper for LanguageMultiSelector component
 * Follows the established RHF pattern from other form components
 */
function RHFLanguageMultiSelector({
  name,
  title,
  description,
  required,
  ...languageSelectorProps
}: RHFLanguageMultiSelectorProps) {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className="mt-4 w-full">
          <FormControl>
            <LanguageMultiSelector
              name={name}
              title={title}
              value={field.value || []}
              onChange={field.onChange}
              {...languageSelectorProps}
            />
          </FormControl>
          {description && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

export default RHFLanguageMultiSelector;
